module.exports = __webpack_public_path__ + "img/About_5.52b1566c.png";